import { SMap } from '@client/new/helpers/types';
import { UpChunk } from '@mux/upchunk';

export type videoSourceType = 's3' | 'mux';

export type Video = {
  creatorId: number;
  id: string;
  videoSourceType: videoSourceType;
  type: string;

  url: string;
  downloadUrl?: string;
  thumbnailUrl: string;

  name: string;
  description?: string;
  createdAt: string;
  updatedAt: string;

  width: number;
  height: number;
  duration: number;
  fileSize: number;
  folderId: number | null;

  isProcessing?: boolean;
  tags?: string[];
};

export type Folder = {
  id: number;
  name: string;
  parentId: number | null;
  updatedAt: string;
};

export type UploadStatus = 'ready' | 'uploading' | 'finished' | 'error';

export type UploadState = {
  progress: number;
  fileName: string;
  fileId: string;
  state: UploadStatus;
  muxInstance: UpChunk;
  folderId: number | null;
};

export type UploadMap = SMap<UploadState>;
export type Videos = Array<Video>;
export type Folders = Array<Folder>;

export const minFileSizeWarning = 1024 * 1024 * 100;
